import { Component, OnInit, Inject, Renderer2 } from '@angular/core';
import { Router } from "@angular/router";
import { AuthenticationService } from "@services/authentication.service";
import { first } from 'rxjs/operators';

import { CommonService } from '@services/app.common.service';
import { HttpClient } from '@angular/common/http';
import { StatusCode } from '../_shared/_enums/Common';
import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
  selector: 'app-no-access',
  templateUrl: './noAccess.component.html',
  styleUrls: ['./noAccess.component.css']
})
   
export class NoAccessComponent  {
  user = {
    userName: '',
    password: ''
  };
  public error: string = '';
  public showLoader: boolean = false;
  data = [];
///*  public _http;*/
//  public _baseUrl;
  public StatusCode = StatusCode;

  constructor(private router: Router, public common: CommonService, public authService: AuthenticationService, http: HttpClient, @Inject('BASE_URL') baseUrl: string, private renderer: Renderer2) {

  }


  public gotoHome() {
    this.common.NavigateToRoute('Home');
  }


}
